import React, { useState, useEffect } from "react";
import { Client, Databases, Query } from "appwrite";
import getFrenchTag from "../../helpers/local_text_helper";
import moment from "moment-timezone";
import Switch from "react-switch";
import axios from "axios";
import { Link } from "react-router-dom";
import {
  Card,
  Col,
  CardBody,
  Row,
  Container,
  ToastHeader,
  ToastBody,
  FormGroup,
  Input,
  Label,
  Spinner,
  InputGroup,
  Button,
  Toast,
  InputGroupText,
  Tooltip,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledTooltip,
  Modal,
  ModalBody,
  ModalFooter,
  Form,
  FormFeedback
} from "reactstrap";
// import * as Yup from "yup";
// import { useFormik } from "formik";
import { withTranslation } from "react-i18next";
import {
  createLog,
  shopifyOauth,
  shopifyOauthCallback,
  klaviyoUpdateProfile
} from "../../helpers/api_helper";
import StaticData from "../../static/data";
import CheckCircleMono from "../../assets/images/icons/CheckCircleMono";
import CustomToast from "../../components/Common/customToast/CustomToast";
import tagDescriptions from "../setup/tagDescriptions";
import InfoMono from "../../assets/images/icons/InfoMono";
import AlertTriangeMono from "../../assets/images/icons/AlertTriangeMono";
import { useNavigate, useLocation } from "react-router-dom";
import { useMixpanel } from "../../Hooks/useMixpanel";
import CheckCircleRounded from "../../assets/images/icons/CheckCircleRounded";
import MdiInformationVariantCircle from "../../assets/images/icons/MdiInformationVariantCircle";
import { fetchClientInfos } from "../../store/actions";
import { useDispatch } from "react-redux";
const daysOfWeek = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday"
];
// const daysOfWeek = ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"];

const General = (props) => {
  const { mixPanelTrack } = useMixpanel();

  // const [site_name, setSiteName] = useState("");
  // const [site_url, setSiteUrl] = useState("");
  const [shopify_store_url, setShopifyStoreUrl] = useState("");
  const [shopify_api_key, setShopifyStoreApiKey] = useState("");
  // const [site_infos_more, setSiteInfosMore] = useState("");
  const [toastMessage, setToastMessage] = useState({});
  const [loading, setLoading] = useState(false);
  const [ressources_data_loading, setRessourcesDataLoading] = useState(false);
  const [toast, setToast] = useState(false);
  const [client_data, setCompanyInfos] = useState(undefined);
  const [cmsDropdown, setCmsDropdown] = useState(false);
  const [selectedCms, setSelectedCms] = useState("Woocommerce");
  const { state } = useLocation();

  // Créez un état pour suivre la couleur sélectionnée
  // const [selectedColor, setSelectedColor] = useState(localStorage.getItem("selectedColor") || "#0bb197");

  // const [selectedTimezone, setSelectedTimezone] = useState("");

  const [product_loading, setProductLoading] = useState(false);
  const [isMonoProductStore, setStoreMonoProductState] = useState(false);
  const [productFetchError, setProductFetchError] = useState("");
  const [products, setProducts] = useState(undefined);
  const [mainProduct, setAsMainProduct] = useState(undefined);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const tagsList = StaticData.tagsList;
  const [expandedItems, setExpandedItems] = useState([]);
  const [selectedTagNameList, setSelectedTagNameList] = useState([]);
  const [tooltip, setTooltip] = useState(false);
  const [isDiconnected, setIsDisconnected] = useState(false);
  const [domain, setDomain] = useState(undefined);
  const [isValid, setIsValid] = useState(true);
  const [savedDomain, setSavedDomain] = useState(undefined);
  const [loadingDomain, setLoadingDomain] = useState(false);
  const [isDeleteDomain, setIsDeleteDomain] = useState(false);

  const toggleItem = (index, tag) => {
    if (expandedItems.includes(index)) {
      console.log("toggleItem includes", index, tag);
      setSelectedTagNameList(
        selectedTagNameList.filter((item) => item !== tag.Name)
      );
      setExpandedItems(expandedItems.filter((item) => item !== tag.Name));
    } else {
      console.log("toggle no", index, tag);
      setSelectedTagNameList([...selectedTagNameList, tag.Name]);
      setExpandedItems([...expandedItems, tag.Name]);
    }
    console.log("selectedTagNameList", selectedTagNameList);
  };
  const removeItem = (index, tag) => {
    console.log("toggle remove", index, tag);
    console.log("selectedTagNameList is", selectedTagNameList);
    console.log("expandedItems is", expandedItems);
    setSelectedTagNameList(selectedTagNameList.filter((item) => item !== tag));
    setExpandedItems(expandedItems.filter((item) => item !== tag));
  };
  // color switch to static folder
  // ! to access call StaticData.colors

  async function disconnectStore() {
    onLoadingChanged(true);
    toggleDisconnect();
    await updateCompanyInfos(
      {
        shopify_store_url: null,
        shopify_token: null
      },
      ["shopify_store_disconnected"]
    );
    onLoadingChanged(false);
    getClientData();
    dispatch(fetchClientInfos());
  }

  async function deleteDomain() {
    onAddDomaine(true);
    toggleDeleteDomain();
    await updateCompanyInfos(
      {
        company_website_url: null
      },
      ["domain_name_deleted"]
    );
    setDomain(undefined);
    setSavedDomain(undefined);
    onAddDomaine(false);
  }

  async function shopifyAuthentication() {
    await shopifyOauth(shopify_store_url);
  }

  async function updateRessources() {
    const companyId = localStorage.getItem("companyId");

    if (companyId) {
      if ((client_data.contact_reasons ?? []) !== selectedTagNameList) {
        onRessourcesDataLoading(true);
        await updateCompanyInfos(
          {
            contact_reasons: selectedTagNameList
          },
          ["tag_updated"]
        );

        var category_percentage =
          (selectedTagNameList.length * 100) / (tagsList.length + 1);
        var percentage_maaia;
        if (category_percentage < 30) {
          percentage_maaia = "-30%";
        } else if (category_percentage >= 30 && category_percentage < 50) {
          percentage_maaia = "30% - 50%";
        } else if (category_percentage >= 50 && category_percentage < 80) {
          percentage_maaia = "50% - 80%";
        } else if (category_percentage >= 80) {
          percentage_maaia = "+80%";
        }

        const updates = {
          properties: {
            category_percentage: percentage_maaia
          }
        };

        klaviyoUpdateProfile(client_data.$id, updates);
      }
      onRessourcesDataLoading(false);
    } else {
      onRessourcesDataLoading(false);
      console.log("no company id");
    }
  }

  async function addDomaine() {
    const companyId = localStorage.getItem("companyId");
    onAddDomaine(true);

    if (companyId) {
      const clients = await getClientInfosHaveDomain();
      console.log({ clients: clients });
      if (clients && clients.length === 0) {
        const response = await updateDomainCompanyInfos({
          company_website_url: domain
        });
        if (response) {
          dispatch(fetchClientInfos());
          let logdata = {
            event: "add_domain",
            author_id: JSON.parse(localStorage.getItem("authUser")).userId,
            company_id: client_data.$id,
            log_data: JSON.stringify({
              eventCreatedAt: response?.$createdAt,
              author_id: JSON.parse(localStorage.getItem("authUser")).userId,
              company_id: client_data.$id
            })
          };
          createLog(logdata, mixPanelTrack);
          setSavedDomain(domain);
        } else {
          setToastMessage({
            header: props.t("Echec"),
            body: "Échec d'ajout du domaine",
            key: "danger"
          });
          toggleToast();
        }
      } else if (clients && clients.length > 0) {
        setToastMessage({
          header: props.t("Echec"),
          body: "Nom de domaine déjà utilisé",
          key: "danger"
        });
        toggleToast();
      } else {
        setToastMessage({
          header: props.t("Echec"),
          body: "Erreur inattendue",
          key: "danger"
        });
        toggleToast();
      }
      onAddDomaine(false);
    } else {
      onAddDomaine(false);
      console.log("no company id");
    }
  }

  const onMainProduct = (product) => {
    setAsMainProduct(product);
  };
  const onLoading = (val) => {
    setLoading(val);
  };
  const onRessourcesDataLoading = (val) => {
    setRessourcesDataLoading(val);
  };
  const onProductLoading = (val) => {
    setProductLoading(val);
  };
  const fetchProducts = async () => {
    onProductLoading(true);
    try {
      const url = "/shopify-products";
      const response = await fetchData(url, shopify_store_url, shopify_api_key);
      if (response.products) {
        console.log("shopify-products is", response.products);
        onProducts(response.products);
      } else {
        setProductFetchError("Échec de chargement des produits");
      }

      onProductLoading(false);
    } catch (error) {
      console.log("Error response", error.response);
      if (error.message && error.message.includes("404")) {
        setProductFetchError("Échec de chargement des produits");
      } else if (error.message && error.message.includes("401")) {
        setProductFetchError("Échec de chargement des produits");
      } else {
        setProductFetchError("Échec de chargement des produits");
      }
      onProductLoading(false);
    }
  };
  const fetchData = async (url, shopify_store_url, shopify_api_key) => {
    onLoading(true);

    const baseUrl = `https://ai.semecloud.tech${url}`;
    try {
      const response = await axios.get(baseUrl, {
        params: {
          shopify_api_key,
          shopify_store_url
        }
      });
      onLoading(false);
      return response;
    } catch (error) {
      onLoading(false);
      console.error("Error", error);
      throw error;
    }
  };
  const onProducts = (val) => {
    setProducts(val);
  };

  const onAddDomaine = (val) => {
    setLoadingDomain(val);
  };

  // Fonction pour gérer la sélection d'une couleur
  // const handleColorSelect = (color) => {
  //   setSelectedColor(color);
  //   console.log("colors is " + color);
  //   localStorage.setItem("selectedColor", color); // Store the selected color in localStorage
  // };
  // Form validation
  // const validationType = useFormik({
  //   // enableReinitialize : use this flag when initial values needs to be changed
  //   enableReinitialize: true,

  //   initialValues: {
  //     username: "",
  //     password: "",
  //     password1: "",
  //     email: "",
  //     digits: "",
  //     number: "",
  //     alphanumeric: "",
  //   },
  //   validationSchema: Yup.object().shape({
  //     username: Yup.string().required("This value is required"),
  //     password: Yup.string().required("This value is required"),
  //     password1: Yup.string().when("password", {
  //       is: (val) => (val && val.length > 0 ? true : false),
  //       then: Yup.string().oneOf(
  //         [Yup.ref("password")],
  //         "Both password need to be the same"
  //       ),
  //     }),
  //     email: Yup.string()
  //       .email("Must be a valid Email")
  //       .max(255)
  //       .required("Email is required"),
  //     url: Yup.string()
  //       .matches(
  //         /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
  //         "Enter correct url!"
  //       )
  //       .required("Please enter correct Url"),
  //     digits: Yup.number().required("Please Enter Your Digits"),
  //     number: Yup.number().required("Please Enter Your Number"),
  //     alphanumeric: Yup.string()
  //       .matches(/^[a-z0-9]+$/i, "Enter correct Alphanumeric!")
  //       .required("Please Enter Your Alphanumeric"),
  //     textarea: Yup.string().required("Please Enter Your Textarea"),
  //   }),
  //   onSubmit: (values) => {
  //     console.log("values", values);
  //   },
  // });
  const initialTimesByDay = {};
  daysOfWeek.forEach((day) => {
    initialTimesByDay[day] = {
      checked: false,
      open: null,
      close: null
    };
  });
  // const [timesByDay, setTimesByDay] = useState(initialTimesByDay);

  // const handleTimeChange = (day, timeType, time) => {
  //   setTimesByDay((prevState) => {
  //     const isAlreadyChecked = prevState[day].checked;
  //     return {
  //       ...prevState,
  //       [day]: {
  //         ...prevState[day],
  //         checked: true,
  //         [timeType]: time,
  //       },
  //     };
  //   });
  //   console.log("***********timesByDay***********", timesByDay);
  // };
  async function updateDomainCompanyInfos(data) {
    console.log("***********clientData***********", data);
    const client = new Client();
    const databases = new Databases(client, "default");

    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);

    const response = await databases.updateDocument(
      "default",
      "client_infos",
      localStorage.getItem("companyId"),
      data
    );

    return response;
  }

  async function updateCompanyInfos(data, eventTable) {
    console.log("***********clientData***********", data);
    const client = new Client();
    const databases = new Databases(client, "default");

    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);

    const promise = databases.updateDocument(
      "default",
      "client_infos",
      localStorage.getItem("companyId"),
      data
    );
    promise.then(
      async function (response) {
        setToastMessage({
          header: props.t("Succès"),
          body: props.t("Modifications effectuées"),
          key: "success"
        });
        toggleToast();
        console.log(response);
        // Créer le log
        var user_id = JSON.parse(localStorage.getItem("authUser")).userId;
        let logData = {
          eventCreatedAt: response?.$createdAt,
          author_id: user_id,
          company_id: client_data.$id
        };
        eventTable.forEach((event_type) => {
          let logdata = {
            event: event_type,
            author_id: user_id,
            company_id: client_data.$id,
            log_data: JSON.stringify(logData)
          };
          createLog(logdata, mixPanelTrack);
        });
      },
      function (error) {
        onLoadingChanged(false);
        onRessourcesDataLoading(false);
        setToastMessage({
          header: props.t("Echec"),
          body: error.message,
          key: "danger"
        });
        toggleToast();
        console.log(error); // Failure
      }
    );
  }
  // const convertTimesByDayToArray = () => {
  //   const timesArray = [];
  //   daysOfWeek.forEach((day) => {
  //     if (timesByDay[day].checked) {
  //       let dayEntry = {};
  //       dayEntry[day] = {
  //         open_time: timesByDay[day].open || "undefined",
  //         close_time: timesByDay[day].close || "undefined",
  //         time_zone: selectedTimezone || "",
  //       };
  //       timesArray.push(JSON.stringify(dayEntry));
  //     }
  //   });
  //   return timesArray;
  // };

  // const handlePrintTimes = async () => {
  //   console.log('PrintTimes', timesByDay);
  //   const errors = {};

  //   daysOfWeek.forEach((day) => {
  //     if (timesByDay[day].checked) {
  //       if (!timesByDay[day].open || !timesByDay[day].close) {
  //         errors[day] = "Veuillez sélectionner les heures d'ouverture et de fermeture.";
  //       }
  //       if (timesByDay[day].open > timesByDay[day].close) {
  //         errors[day] = "L'heure d'ouverture doit être antérieure à l'heure de fermeture.";
  //       }
  //     }
  //   });

  //   if (Object.keys(errors).length > 0) {
  //     setFormErrors(errors);
  //   } else {
  //     setFormErrors({});
  //     const timesArrayNew = [];
  //     onLoadingChanged(true);
  //     await updateCompanyInfos({
  //       times_by_day: convertTimesByDayToArray(timesByDay),
  //       time_zone: selectedTimezone,
  //     });
  //     onLoadingChanged(false);

  //     getClientData();
  //   }
  // };

  const onLoadingChanged = (val) => {
    setLoading(val);
  };
  const toggleToast = () => {
    console.log("setToast before: " + toast);
    setToast(true);
    console.log("setToast after: " + toast);

    setTimeout(() => {
      setToast(false);
    }, 3000);
  };
  // const requiredValidations = () => {
  //   if (
  //     site_name &&
  //     site_name !== null &&
  //     site_name !== "" &&
  //     site_url &&
  //     site_url !== null &&
  //     site_url !== "" &&
  //     shopify_store_url &&
  //     shopify_store_url !== null &&
  //     shopify_store_url !== "" &&
  //     shopify_api_key &&
  //     shopify_api_key !== null &&
  //     shopify_api_key !== ""
  //   ) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // };

  const getClientData = async function () {
    const client = new Client();

    const databases = new Databases(client, "default");

    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);

    const promise = databases.getDocument(
      "default",
      "client_infos",
      localStorage.getItem("companyId")
    );

    promise.then(
      function (response) {
        //   const updatedTimesByDay = { ...initialTimesByDay };
        // console.log("general before", response.times_by_day);
        // response.times_by_day.forEach((entry) => {
        //   if (entry) {
        //     let element = JSON.parse(entry);
        //     console.log("element is", element);
        //     const day = Object.keys(element)[0];
        //     console.log("day is", day);
        //     const openingTimeMatch = element[day]["open_time"];
        //     const closingTimeMatch = element[day]["close_time"];
        //     console.log("openingTimeMatch is", openingTimeMatch);
        //     console.log("closingTimeMatch is", closingTimeMatch);

        //     if (day && openingTimeMatch && closingTimeMatch) {
        //       const openingTime = parseInt(openingTimeMatch);
        //       const closingTime = parseInt(closingTimeMatch);
        //       // const openingTime = openingTimeMatch[1];
        //       // const closingTime = closingTimeMatch[1];
        //       console.log("general new", updatedTimesByDay);
        //       updatedTimesByDay[day] = {
        //         ...updatedTimesByDay[day],
        //         checked: true,
        //         open: openingTime,
        //         close: closingTime,
        //       };
        //     }
        //   }
        // });
        // console.log("setTimesByDay", updatedTimesByDay);
        // setTimesByDay(updatedTimesByDay);
        setCompanyInfos(response);
        console.log("company info is ", response);
        setSavedDomain(response.company_website_url);
        // setSiteName(response.company ?? "");
        // setSiteUrl(response.company_website_url ?? "");
        // setSiteInfosMore(response.more_info ?? "");
        setShopifyStoreUrl(response.shopify_store_url ?? "");
        setShopifyStoreApiKey(response.shopify_token ?? "");
        if (response.shopify_token) {
          setSelectedCms("Shopify");
        }
        // setSelectedTimezone(response.time_zone ?? setUtc(moment.tz.guess(true)));
        setStoreMonoProductState(response.mono_product_store);
        setSelectedTagNameList(response.contact_reasons ?? []);
        setExpandedItems(response.contact_reasons ?? []);
        setLoading(false);
        return response;
      },
      function (error) {
        setLoading(false);
        console.log(error);
        return null;
      }
    );
  };

  // function setUtc(timezone) {
  //   const timeutc = moment.tz(timezone).utcOffset() / 60;
  //   const optionText = `${timezone} (UTC${timeutc >= 0 ? "+" : ""}${timeutc})`;
  //   return optionText;
  // }
  // const timeutc = moment.tz('Africa/Juba').format('z');
  // console.log("toto",timeutc);
  // console.log("toto",timezones);
  useEffect(() => {
    getClientData();
  }, []);

  useEffect(() => {
    if (state && state.auth === "prestashop") {
      setSelectedCms("Prestashop");
    }
  }, [state]);

  const svgs = {
    timezone: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
      >
        <g filter="url(#filter0_d_1148_1762)">
          <rect
            x="12"
            y="8"
            width="40"
            height="40"
            rx="6.75556"
            fill="#FFFAF1"
          />
        </g>
        <path
          style={{
            strokeWidth: "3",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }}
          d="M25 24L32.5 32L40 24"
          stroke="#FFA412"
        />
        <defs>
          <filter
            id="filter0_d_1148_1762"
            x="0.9"
            y="0.9"
            width="62.2"
            height="62.2"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="5.55" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_1148_1762"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_1148_1762"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    ),
    plus_icon: (
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.01667 13.7836C6.62474 13.7836 6.32189 13.6767 6.10811 13.4629C5.89433 13.2313 5.78744 12.9195 5.78744 12.5276V8.14517H1.48517C1.11106 8.14517 0.817111 8.04719 0.603333 7.85123C0.389556 7.63745 0.282667 7.34351 0.282667 6.96939C0.282667 6.59528 0.389556 6.31025 0.603333 6.11428C0.817111 5.9005 1.11106 5.79362 1.48517 5.79362H5.78744V1.54478C5.78744 1.15286 5.89433 0.850005 6.10811 0.636227C6.32189 0.422449 6.63365 0.315561 7.04339 0.315561C7.43532 0.315561 7.72926 0.422449 7.92522 0.636227C8.139 0.850005 8.24589 1.15286 8.24589 1.54478V5.79362H12.5482C12.9401 5.79362 13.234 5.9005 13.43 6.11428C13.6438 6.31025 13.7507 6.59528 13.7507 6.96939C13.7507 7.34351 13.6438 7.63745 13.43 7.85123C13.234 8.04719 12.9401 8.14517 12.5482 8.14517H8.24589V12.5276C8.24589 12.9195 8.139 13.2313 7.92522 13.4629C7.72926 13.6767 7.42641 13.7836 7.01667 13.7836Z"
          fill="currentColor"
        />
      </svg>
    ),
    check_icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="15"
        viewBox="0 0 21 15"
        fill="none"
      >
        <path
          d="M20.9949 2.0168C20.8615 2.5003 20.5279 2.84638 20.1842 3.18738C16.4077 6.92815 12.6313 10.674 8.86001 14.4199C8.44439 14.8321 7.96721 15.051 7.37201 14.9899C6.96153 14.9492 6.61775 14.7609 6.33041 14.4759C4.39089 12.5571 2.45136 10.6435 0.52723 8.71456C-0.334782 7.84934 -0.103886 6.5159 0.958235 5.99677C1.62014 5.67105 2.36927 5.81355 2.94394 6.38357C4.16512 7.59487 5.38631 8.80617 6.60749 10.0175C6.88456 10.2923 7.16164 10.562 7.43358 10.8369C7.53107 10.9387 7.60291 10.9387 7.7004 10.8369C7.9826 10.5468 8.2802 10.2618 8.56754 9.97166C11.7077 6.85689 14.853 3.73704 17.9932 0.622277C18.4088 0.210029 18.8758 -0.0444449 19.4863 0.00644996C20.1483 0.0624343 20.7383 0.520488 20.9333 1.15158C20.9538 1.20757 20.9795 1.26355 21 1.31954C20.9949 1.55365 20.9949 1.78268 20.9949 2.0168Z"
          fill="white"
        />
      </svg>
    ),
    close_icon: (
      <svg
        width="11"
        height="12"
        viewBox="0 0 11 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.36078 3.13406C7.5521 2.93171 7.89946 2.92198 8.10181 3.11331L8.4827 3.47345C8.69695 3.67602 8.69477 4.01213 8.50345 4.21448L6.88282 5.92849L8.59683 7.54912C8.81108 7.7517 8.80891 8.0878 8.61758 8.29015L8.25744 8.67104C8.05486 8.88529 7.73066 8.89437 7.51641 8.69179L5.8024 7.07116L4.18177 8.78517C3.97919 8.99942 3.65499 9.0085 3.44074 8.80592L3.05985 8.44578C2.8575 8.25446 2.83652 7.919 3.0391 7.70475L4.65973 5.99074L2.94572 4.37011C2.74337 4.17879 2.72239 3.84333 2.92497 3.62908L3.28511 3.24819C3.47643 3.04584 3.82379 3.03612 4.02614 3.22744L5.74015 4.84807L7.36078 3.13406Z"
          fill="#563BFF"
        />
      </svg>
    ),
    folder_icon: (
      <svg
        width="19"
        height="12"
        viewBox="0 0 19 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.4688 5C17.6562 5 18.375 6.3125 17.75 7.3125L15.25 11.3125C14.9688 11.75 14.5 12 14 12H1.5C0.65625 12 0 11.3438 0 10.5V1.5C0 0.6875 0.65625 0 1.5 0H6.5L8.5 2H13.5C14.3125 2 15 2.6875 15 3.5V5H16.4688ZM1.5 1.6875V9L3.4375 5.75C3.71875 5.28125 4.21875 5 4.75 5H13.5V3.6875C13.5 3.59375 13.4062 3.5 13.3125 3.5H7.875L5.875 1.5H1.6875C1.5625 1.5 1.5 1.59375 1.5 1.6875ZM14 10.5L16.5 6.5H4.65625L2.25 10.5H14Z"
          fill="#737791"
        />
      </svg>
    ),
    shopify_icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 256 292"
      >
        <path
          fill="#95BF46"
          d="M223.774 57.34c-.201-1.46-1.48-2.268-2.537-2.357a19614 19614 0 0 0-23.383-1.743s-15.507-15.395-17.209-17.099c-1.703-1.703-5.029-1.185-6.32-.805c-.19.056-3.388 1.043-8.678 2.68c-5.18-14.906-14.322-28.604-30.405-28.604c-.444 0-.901.018-1.358.044C129.31 3.407 123.644.779 118.75.779c-37.465 0-55.364 46.835-60.976 70.635c-14.558 4.511-24.9 7.718-26.221 8.133c-8.126 2.549-8.383 2.805-9.45 10.462C21.3 95.806.038 260.235.038 260.235l165.678 31.042l89.77-19.42S223.973 58.8 223.775 57.34M156.49 40.848l-14.019 4.339c.005-.988.01-1.96.01-3.023c0-9.264-1.286-16.723-3.349-22.636c8.287 1.04 13.806 10.469 17.358 21.32m-27.638-19.483c2.304 5.773 3.802 14.058 3.802 25.238c0 .572-.005 1.095-.01 1.624c-9.117 2.824-19.024 5.89-28.953 8.966c5.575-21.516 16.025-31.908 25.161-35.828m-11.131-10.537c1.617 0 3.246.549 4.805 1.622c-12.007 5.65-24.877 19.88-30.312 48.297l-22.886 7.088C75.694 46.16 90.81 10.828 117.72 10.828"
        />
        <path
          fill="#5E8E3E"
          d="M221.237 54.983a19614 19614 0 0 0-23.383-1.743s-15.507-15.395-17.209-17.099c-.637-.634-1.496-.959-2.394-1.099l-12.527 256.233l89.762-19.418S223.972 58.8 223.774 57.34c-.201-1.46-1.48-2.268-2.537-2.357"
        />
        <path
          fill="#FFF"
          d="m135.242 104.585l-11.069 32.926s-9.698-5.176-21.586-5.176c-17.428 0-18.305 10.937-18.305 13.693c0 15.038 39.2 20.8 39.2 56.024c0 27.713-17.577 45.558-41.277 45.558c-28.44 0-42.984-17.7-42.984-17.7l7.615-25.16s14.95 12.835 27.565 12.835c8.243 0 11.596-6.49 11.596-11.232c0-19.616-32.16-20.491-32.16-52.724c0-27.129 19.472-53.382 58.778-53.382c15.145 0 22.627 4.338 22.627 4.338"
        />
      </svg>
    ),
    woocommerce_icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 128 128"
      >
        <path
          fill="#7f54b3"
          d="M116.3 89.1H11.7C5.2 89.1 0 83.9 0 77.4v-40C0 31 5.2 25.8 11.7 25.8h104.7c6.4 0 11.7 5.2 11.7 11.7v40c-.1 6.4-5.3 11.6-11.8 11.6"
        />
        <path
          fill="#FFF"
          d="M13.8 76.7s2.8 11.8 8.5 3.9s11.2-20.3 11.2-20.3s.4-3.1 2 3.7S44 80 44 80s6.3 7.9 8.9-.4c-1-11 2.8-31 6.7-40.6c1.6-8.5-7.3-6.1-8.1-4.1s-6.3 14.8-6.7 28.2c0 0-4.7-12.8-5.1-17.4c-.4-4.7-5.3-5.9-8.1-1.4S20.3 66.2 20.3 66.2l-5.5-28.4s-5.5-7.3-8.7 1.6c0 0 5.7 34.9 7.7 37.3m73.2-31c-8.5-14.2-21.1-3.4-21.1-3.4s-9.6 11.1-5.3 26.2c6.9 14.9 16.6 8.3 19.2 7.1c2.7-1.3 14.1-14.3 7.2-29.9m-6.5 12.5c0 5.9-4.9 11.4-8.9 10.2c-2.2-1.3-3.6-4.8-3.6-10.8c2-9.7 6.4-11 8.7-10.8c4.3 2.3 4.1 7.4 3.8 11.4m38.4-12.5c-8.5-14.2-21.1-3.4-21.1-3.4s-9.6 11.1-5.3 26.2c6.9 14.9 16.6 8.3 19.2 7.1c2.6-1.3 14.1-14.3 7.2-29.9m-6.5 12.5c0 5.9-4.9 11.4-8.9 10.2c-2.2-1.3-3.6-4.8-3.6-10.8c2-9.7 6.4-11 8.7-10.8c4.2 2.3 4 7.4 3.8 11.4"
        />
        <path fill="#7f54b3" d="m61.3 89.1l22.3 13.1l-4.7-13.1l-12.8-3.6z" />
      </svg>
    ),
    magento_icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 128 128"
      >
        <path
          fill="#f26322"
          d="M119.82 31.97v64.01l-15.85 9.12V41.17l-39.62-22.9l-39.64 22.9l.1 63.96l-15.82-9.15V32.02L64.45 0zM72.3 105.1l-7.9 4.6l-7.95-4.55V41.17l-15.82 9.15l.03 63.96L64.38 128l23.77-13.72V50.29L72.3 41.14z"
        />
      </svg>
    ),
    prestashop_icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path
          fill="currentColor"
          d="M11.558 1.034C5.174 1.034 0 6.21 0 12.592c0 1.258.201 2.47.574 3.597l.002-.007a12.4 12.4 0 0 1 .53-1.787l.011-.03q.129-.333.277-.66l.084-.181q.12-.256.253-.507q.053-.102.108-.203c.02-.038.044-.073.064-.11q.14-.25.29-.493l.075-.114q.187-.292.393-.573l.035-.05q.217-.289.451-.563l.1-.118q.232-.266.481-.517l.099-.097a10 10 0 0 1 .546-.503c.74-2.48 3.005-4.285 5.686-4.285c1.079 0 2.152.31 3.071.873a6 6 0 0 1 2.211 2.407l.007.015l.04.074v.003l.004.002a10 10 0 0 1 1.567 1.198l.12.109c.002 0 .006.005.007.006l-.002-.006l-.001-.004v-.003l.042-.084c.377-2.384 1.43-4.102 2.67-4.102c.934 0 1.762.975 2.276 2.476l.005.016l.001.002q.218.236.424.521l.007.01l.021.067l-.02-.078c-1.542-4.569-5.863-7.857-10.952-7.857zM9.927 5.477C7.586 5.52 5.34 7.132 4.574 9.365l-.012.034a10 10 0 0 1 1.315-.895c2.806-1.656 6.479-1.646 9.278.016c-.895-1.653-2.631-2.819-4.5-3.004a5 5 0 0 0-.728-.039m9.834.5a1.4 1.4 0 0 0-.39.067c-1.265.562-1.719 2.073-2.031 3.303l-.016.072c.365-.62.808-1.215 1.396-1.642c.835-.687 2.105-.655 2.916.053c.308.326.141.008.031-.22c-.342-.75-1.025-1.653-1.906-1.634zM12.35 8.315l-1.07 3.27l-.002.005l-.006.002l-4.498 1.112h-.009l4.456 1.087q.159.166.36.28h.002q.063.035.129.065l.01.005q.062.026.126.047l.021.008q.06.019.12.032l.033.008a1.7 1.7 0 0 0 .318.033a1.55 1.55 0 0 0 1.43-.948c.08-.186.123-.39.123-.604v-.011l-.001-.012a2 2 0 0 0-.01-.16l-.001-.002a2 2 0 0 0-.026-.153l-.001-.004a1.5 1.5 0 0 0-.096-.288v-.003a1.5 1.5 0 0 0-.348-.49v-.003zm3.148.626c.048 1.008.036 2.046-.1 3.057c-.17 2.018-1.19 3.798-1.972 5.616l-.03.08l-.035.086c1.51-1.522 3.17-3.04 3.969-5.082c.383-.636.118-1.342-.115-1.976c-.17-.877-1.069-1.278-1.717-1.781m6.172.572l-.588 2.688a2 2 0 0 0-.047.2l-.01.06a2 2 0 0 0-.016.222l-.002.031h.003c0 .628.297 1.136.663 1.137a.4.4 0 0 0 .182-.045l.027-.015l.07-.047q.019-.016.036-.033a.8.8 0 0 0 .137-.168l.03-.054a1 1 0 0 0 .052-.108l.017-.04q.03-.08.053-.166l.002-.002l.001-.003l.404-.451l-.407-.456v.001l-.02-.063zm-4.381.856c.69 1.716.85 3.707.091 5.43c-.49 1.368-1.587 2.463-1.874 3.905q1.096.172 2.21.186c2.166.029 4.332-.42 6.284-1.365c-2.04-2.869-4.121-5.755-6.711-8.156m-4.948.977a.583.583 0 1 1 0 1.166a.583.583 0 0 1 0-1.166m9.352.37c.138 0 .249.19.249.426s-.111.426-.249.426c-.137 0-.248-.19-.248-.426c0-.235.11-.426.248-.426m-4.044.184a5 5 0 0 1-.05.29l-.006.023q-.016.076-.033.128c-.48 1.417-1.275 2.52-2.36 3.697q-.221.239-.459.484a59 59 0 0 1-1.196 1.205c-.112.11-.259.261-.425.436c-.103.287-.22.61-.318.95q-.065-.023-.131-.049c-2.108-.815-3.519-1.904-3.519-1.904s1.086 1.414 2.915 2.74q.265.192.522.339c-.075 1.194.452 2.34 2.83 2.682a4.8 4.8 0 0 0 1.228.008l-.01-.029l-.004-.01s-.167-.133-.379-.377a3.8 3.8 0 0 1-.584-.897a3.4 3.4 0 0 1-.266-.862a3.2 3.2 0 0 1-.006-.972q.025-.18.072-.366c.093-.374.255-.772.507-1.192l.002-.003l.241-.404c1.103-1.86 1.797-3.275 1.506-5.441a9 9 0 0 0-.078-.476zm4.681.779l.003.036v.01l-.003.038l.003-.043q0-.02-.003-.04zm-.012.275l-.002.01l-.002.014zm1.353 5.928c-2.553 1.138-5.44 1.44-8.192 1.007c-.14 1.108.384 2.218 1.214 2.93l.012.01c2.703-.433 4.975-2.168 6.966-3.946z"
        />
      </svg>
    ),
    e_commerce: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="2.5em"
        height="2.5em"
        viewBox="0 0 24 24"
      >
        <path
          fill="#96BF48"
          d="M14.5 21.991V18.5c0-.935 0-1.402-.201-1.75a1.5 1.5 0 0 0-.549-.549C13.402 16 12.935 16 12 16s-1.402 0-1.75.201a1.5 1.5 0 0 0-.549.549c-.201.348-.201.815-.201 1.75v3.491z"
        ></path>
        <path
          fill="#96BF48"
          fillRule="evenodd"
          d="M5.732 12c-.89 0-1.679-.376-2.232-.967V14c0 3.771 0 5.657 1.172 6.828c.943.944 2.348 1.127 4.828 1.163h5c2.48-.036 3.885-.22 4.828-1.163C20.5 19.657 20.5 17.771 20.5 14v-2.966a3.06 3.06 0 0 1-5.275-1.789l-.073-.728a3.167 3.167 0 1 1-6.307.038l-.069.69A3.06 3.06 0 0 1 5.732 12m8.768 6.5v3.491h-5V18.5c0-.935 0-1.402.201-1.75a1.5 1.5 0 0 1 .549-.549C10.598 16 11.065 16 12 16s1.402 0 1.75.201a1.5 1.5 0 0 1 .549.549c.201.348.201.815.201 1.75"
          clipRule="evenodd"
          opacity=".5"
        ></path>
        <path
          fill="#96BF48"
          d="M9.5 2h5l.652 6.517a3.167 3.167 0 1 1-6.304 0z"
        ></path>
        <path
          fill="#96BF48"
          d="M3.33 5.351c.178-.89.267-1.335.448-1.696a3 3 0 0 1 1.889-1.548C6.057 2 6.51 2 7.418 2h2.083l-.725 7.245a3.06 3.06 0 1 1-6.044-.904zm17.34 0c-.178-.89-.267-1.335-.448-1.696a3 3 0 0 0-1.888-1.548C17.944 2 17.49 2 16.582 2H14.5l.725 7.245a3.06 3.06 0 1 0 6.043-.904z"
          opacity=".7"
        ></path>
      </svg>
    )
  };

  function toggleDisconnect() {
    setIsDisconnected(!isDiconnected);
  }

  function toggleDeleteDomain() {
    setIsDeleteDomain(!isDeleteDomain);
  }

  const validateDomain = (value) => {
    // Correspond à des domaines du type "example.com" ou "example.co.uk"
    const domainRegex = /^[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/;
    return domainRegex.test(value);
  };

  const handleChange = (e) => {
    let value = e.target.value;
    // Mettre à jour la valeur et valider le nom de domaine
    setDomain(value);
    setIsValid(validateDomain(value));
  };

  const handleOnBlur = () => {
    let res = domain;
    if (domain && domain.toLowerCase().startsWith("www.")) {
      res = domain.replace("www.", "");
    }
    setDomain(res);
    setIsValid(validateDomain(res));
  };

  async function getClientInfosHaveDomain() {
    const client = new Client();
    const databases = new Databases(client, "default");

    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);

    const promise = databases.listDocuments("default", "client_infos", [
      Query.equal("company_website_url", domain)
    ]);

    return promise.then(
      async function (response) {
        return response.documents;
      },
      function (error) {
        console.log("Error listing client_infos ", error);
        return null;
      }
    );
  }

  return (
    <React.Fragment>
      {client_data ? (
        <Container
          fluid={true}
          style={{ maxWidth: "100%", paddingLeft: "8%", paddingRight: "8%" }}
          className="general"
        >
          {/* {timesByDay ? ( */}

          {/* Horaires Sections */}
          {/* <form className="d-flex justify-content-center" onSubmit={(e) => {
                    e.preventDefault();
                    handlePrintTimes();
                }}>
                    <Col xxl={10} lg={12}>
                        <Card style={{backgroundColor: "transparent", boxShadow:"none"}}>
                            <CardBody style={{padding:"0"}}>
                                <Row className="align-items-center justify-content-between flex-row mb-5">
                                    <div style={{ width: "fit-content" }}><h4 className="section-title mb-0">Horaires d'activité iAssistant</h4></div>
                                    <div className="d-flex" style={{ height: "fit-content", width: "fit-content" }}>
                                        <i
                                            className="font-size-20 me-3"
                                            style={{
                                                color: "#FFA412",
                                                cursor: "pointer",
                                            }}
                                            onClick={() => { }}
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="19"
                                                height="18"
                                                viewBox="0 0 19 18"
                                                fill="none"
                                            >
                                                <path
                                                    d="M3.00256 16.425C3.03496 15.9327 3.14298 15.4512 3.22399 14.9697C3.3968 13.9202 3.58043 12.8707 3.76405 11.8212C3.79645 11.6481 3.73704 11.5291 3.61823 11.41C2.56511 10.3822 1.51739 9.3543 0.46967 8.32102C-0.124398 7.73135 -0.156801 6.84954 0.38326 6.21659C0.658692 5.89199 1.02593 5.74593 1.44178 5.68642C2.86754 5.48084 4.29331 5.27527 5.71907 5.07511C5.88109 5.05347 5.9675 4.96691 6.03231 4.83166C6.67498 3.51707 7.32845 2.20788 7.97113 0.893285C8.15475 0.520005 8.43558 0.249512 8.82443 0.103446C9.57511 -0.183276 10.3798 0.141315 10.747 0.887875C11.3303 2.0564 11.9244 3.22493 12.4752 4.4151C12.6859 4.86953 12.9289 5.10215 13.4582 5.15625C14.7219 5.2915 15.9748 5.5133 17.2332 5.68642C18.0271 5.80003 18.5401 6.21659 18.686 6.91446C18.8048 7.4879 18.6373 7.9802 18.2215 8.38594C17.1954 9.39217 16.1693 10.393 15.1377 11.3938C14.9811 11.5453 14.9433 11.6914 14.9811 11.8969C15.235 13.3251 15.4834 14.7533 15.7156 16.1815C15.8128 16.7874 15.6238 17.3122 15.1215 17.6801C14.6193 18.0534 14.0576 18.102 13.5014 17.8153C12.2268 17.1553 10.9577 16.4845 9.69392 15.8083C9.4563 15.6784 9.27268 15.6892 9.04045 15.8137C7.78211 16.4899 6.51836 17.1553 5.24922 17.8099C4.41752 18.2373 3.47241 17.8802 3.11057 17.0309C3.02956 16.8253 2.99716 16.6306 3.00256 16.425ZM14.3979 16.4142C14.3925 16.3979 14.3871 16.3709 14.3817 16.3438C14.1494 15.0022 13.9496 13.6551 13.6796 12.3189C13.5122 11.4966 13.6958 10.8582 14.3223 10.2848C15.3052 9.38135 16.2395 8.42922 17.1954 7.49331C17.2818 7.40675 17.4168 7.33102 17.3736 7.17954C17.325 7.00642 17.163 7.02806 17.0388 7.00642C15.6346 6.79544 14.2304 6.58987 12.8263 6.3897C12.2214 6.30314 11.7948 6.0056 11.5247 5.45921C10.9037 4.18789 10.2718 2.91657 9.64532 1.65067C9.58051 1.52083 9.54811 1.3423 9.36449 1.3423C9.18087 1.34771 9.14846 1.52624 9.08906 1.65608C8.46258 2.92739 7.83071 4.1933 7.20964 5.46461C6.96121 5.96773 6.57237 6.27609 6.0215 6.36806C5.63266 6.43298 5.23842 6.48167 4.84417 6.54118C3.76405 6.69806 2.68932 6.86036 1.6092 7.01724C1.50659 7.03347 1.40938 7.0497 1.36617 7.16331C1.32297 7.28233 1.40398 7.35265 1.47419 7.42298C1.79282 7.73675 2.10606 8.04512 2.42469 8.35889C3.16998 9.08922 3.92607 9.81414 4.66595 10.5499C5.02239 10.9015 5.18441 11.3397 5.1088 11.8374C5.00079 12.5623 4.86577 13.2873 4.74156 14.0122C4.60654 14.7912 4.47693 15.5648 4.34191 16.3438C4.32571 16.4412 4.33111 16.517 4.40672 16.5819C4.48233 16.6522 4.56874 16.6306 4.64975 16.5927C4.69835 16.5711 4.74696 16.544 4.79556 16.517C6.04851 15.857 7.30145 15.2024 8.54899 14.5369C9.09986 14.2394 9.63452 14.2448 10.1854 14.5424C11.1899 15.0833 12.1998 15.6081 13.2043 16.1383C13.496 16.2897 13.7876 16.452 14.0846 16.5981C14.2574 16.6847 14.3979 16.5927 14.3979 16.4142Z"
                                                    fill="#FFA412"
                                                />
                                            </svg>
                                        </i>
                                        <button
                                            className="me-3"
                                            style={{
                                                border: "none",
                                                backgroundColor: "#E8F7F7",
                                                padding: "0px 8px",
                                                borderRadius: "5px",
                                                cursor: "pointer",
                                            }}
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="21"
                                                height="20"
                                                viewBox="0 0 21 20"
                                                fill="none"
                                            >
                                                <path
                                                    d="M0 3.8279C0 3.66102 0 3.48892 0 3.32203C0.151239 2.55541 0.318123 1.78879 0.443286 1.01173C0.521512 0.521512 0.745763 0.177314 1.20991 0C1.39244 0 1.57497 0 1.7575 0C1.78879 0.0104302 1.82008 0.0208605 1.85137 0.0260756C4.01565 0.43807 6.17992 0.850065 8.3442 1.26206C10.7066 1.71056 13.0691 2.15906 15.4316 2.60756C16.6623 2.84224 17.8983 3.07171 19.1291 3.3116C19.7445 3.43155 20.0991 3.91656 19.9948 4.5163C19.8435 5.38201 19.6714 6.2425 19.5046 7.103C19.4472 7.40026 19.3012 7.66623 19.0196 7.77053C18.6962 7.89048 18.6441 8.09387 18.6806 8.3807C18.6858 8.40678 18.6806 8.43285 18.6806 8.45893C18.6754 8.56845 18.7119 8.63103 18.8318 8.66754C19.176 8.77184 19.3429 9.0013 19.3429 9.36115C19.3429 12.4694 19.3481 15.5776 19.3429 18.691C19.3429 19.4159 18.7484 20.0052 18.0183 20.0052C12.6728 20.0052 7.32203 20.0052 1.97653 20.0052C1.24641 20.0052 0.657106 19.4159 0.657106 18.691C0.65189 15.5828 0.657106 12.4746 0.657106 9.36115C0.657106 9.0013 0.82399 8.77184 1.16819 8.66754C1.28814 8.63103 1.31943 8.56845 1.31943 8.45893C1.31421 8.1721 1.31943 7.88527 1.31943 7.59843C1.31943 7.35332 1.38722 7.12907 1.55411 6.95176C2.1382 6.35724 2.73272 5.77314 3.32203 5.18905C3.35332 5.15776 3.40548 5.15254 3.40026 5.09518C3.36375 5.05867 3.31682 5.05867 3.26988 5.05345C2.4824 4.90222 1.70013 4.74576 0.912647 4.61017C0.443286 4.52151 0.146023 4.27119 0 3.8279ZM9.99739 9.3455C7.21252 9.3455 4.42764 9.3455 1.64276 9.3455C1.47066 9.3455 1.36115 9.36115 1.36115 9.58018C1.36636 12.5841 1.36115 15.5932 1.36636 18.5971C1.36636 19.0404 1.59061 19.2699 2.02868 19.3064C2.10169 19.3116 2.16949 19.3116 2.2425 19.3116C7.40548 19.3116 12.5737 19.3116 17.7366 19.3116C17.8722 19.3116 18.0078 19.3116 18.1434 19.2751C18.3937 19.2177 18.5763 19.0143 18.6076 18.7588C18.618 18.6701 18.618 18.5763 18.618 18.4876C18.618 15.5463 18.618 12.605 18.618 9.66362C18.618 9.3455 18.618 9.3455 18.3051 9.3455C15.5411 9.3455 12.7666 9.3455 9.99739 9.3455ZM0.709257 3.46806C0.698827 3.74967 0.777053 3.84355 1.01173 3.89048C1.6897 4.02086 2.36245 4.15124 3.04042 4.28162C6.02868 4.85006 9.01695 5.4133 12 5.98175C14.1173 6.38331 16.2399 6.79009 18.3572 7.19166C18.6128 7.23859 18.7536 7.16036 18.8005 6.91004C18.9622 6.08605 19.1186 5.26206 19.2699 4.43807C19.3168 4.1721 19.2282 4.05215 18.957 4C16.7458 3.57757 14.5398 3.16036 12.3286 2.74316C9.35072 2.17992 6.37288 1.61147 3.38983 1.04824C2.8266 0.943937 2.26858 0.83442 1.70535 0.730117C1.33507 0.662321 1.22555 0.735332 1.15254 1.11082C1.07953 1.50196 1.00652 1.88787 0.933507 2.27901C0.85528 2.69622 0.777053 3.11864 0.709257 3.46806ZM5.46023 5.67927C5.0013 5.67927 4.61538 5.68448 4.23468 5.67927C4.08344 5.67927 4.02608 5.73664 4.02608 5.88787C4.03129 6.18514 4.02608 6.48761 4.02608 6.78488C4.02086 7.39505 3.7236 7.69231 3.11343 7.69752C2.82138 7.69752 2.52934 7.70274 2.23729 7.69752C2.10169 7.69752 2.02868 7.74967 2.0339 7.89048C2.03911 8.07301 2.03911 8.25554 2.0339 8.43807C2.0339 8.57888 2.10169 8.63624 2.23729 8.63624C2.97262 8.63624 3.70795 8.63624 4.44328 8.63624C4.58409 8.63624 4.64146 8.57366 4.63625 8.43285C4.63103 8.20339 4.63625 7.97914 4.63625 7.74967C4.64146 7.25424 4.91786 6.98305 5.41851 6.97784C5.9661 6.97784 6.51369 6.97262 7.05606 6.97784C7.22816 6.97784 7.30639 6.92568 7.30117 6.74316C7.29074 6.50847 7.29074 6.27379 7.30117 6.03911C7.30639 5.87223 7.23859 5.80443 7.07692 5.76271C6.51369 5.63233 5.95046 5.69492 5.46023 5.67927ZM15.3168 8.63103C16.0052 8.63103 16.6936 8.63624 17.3872 8.63103C18.0287 8.62581 17.9557 8.73012 17.9557 8.02086C17.9557 8.01565 17.9557 8.01043 17.9557 8C17.9557 7.89048 17.9087 7.83312 17.7992 7.81226C17.648 7.78618 17.4915 7.75489 17.3403 7.7236C15.8801 7.44198 14.4198 7.16558 12.9544 6.88918C12.704 6.84224 12.6936 6.85267 12.6936 7.11343C12.6936 7.53064 12.6936 7.94785 12.6936 8.35984C12.6936 8.60495 12.7145 8.62581 12.9596 8.63103C13.7471 8.63103 14.5346 8.63103 15.3168 8.63103ZM8.00521 8.63103C8.79791 8.63103 9.59061 8.63103 10.3833 8.63103C10.6232 8.63103 10.6389 8.61017 10.6441 8.3807C10.6441 8.25033 10.6441 8.11995 10.6441 7.98957C10.6441 7.69752 10.6441 7.69752 10.352 7.69752C8.87614 7.69752 7.40026 7.69752 5.92438 7.69752C5.80965 7.69752 5.6897 7.70274 5.57497 7.69752C5.4133 7.68709 5.35072 7.76532 5.36115 7.92177C5.36636 8.07301 5.36115 8.21904 5.36115 8.37027C5.36115 8.61538 5.38201 8.63624 5.62712 8.63624C6.41982 8.63103 7.21252 8.63103 8.00521 8.63103ZM11.9687 7.64537C11.9687 7.41069 11.9583 7.17601 11.9739 6.94654C11.9896 6.75358 11.9113 6.68579 11.7288 6.6545C11.1969 6.56063 10.6701 6.45632 10.1382 6.35724C9.50717 6.23729 8.87614 6.11212 8.24511 5.99218C8.02608 5.95046 8.01043 5.96089 8.01043 6.18514C8.01043 6.36245 8.01043 6.53455 8.01043 6.71186C8.01043 6.9674 8.01565 6.97262 8.2764 6.97262C9.06388 6.97262 9.84615 6.97262 10.6336 6.97262C11.03 6.97262 11.3012 7.22295 11.3325 7.61408C11.3533 7.86441 11.3533 8.11995 11.3481 8.37549C11.3429 8.5528 11.4055 8.64668 11.5984 8.63103C11.6506 8.62581 11.7027 8.62581 11.7549 8.63103C11.9166 8.64146 11.9739 8.56323 11.9687 8.40678C11.9635 8.15645 11.9687 7.90091 11.9687 7.64537ZM2.89961 6.97262C3.30639 6.97262 3.30639 6.97262 3.30639 6.58149C3.30639 6.50847 3.30639 6.44068 3.30639 6.36767C3.30639 6.33116 3.31682 6.27901 3.26988 6.26858C3.24902 6.26336 3.21252 6.28944 3.19166 6.3103C3.06128 6.43546 2.9309 6.56584 2.80574 6.69622C2.73794 6.76923 2.5867 6.84746 2.61799 6.92047C2.6545 7.0352 2.81095 6.95176 2.89961 6.97262Z"
                                                    fill="#329993"
                                                />
                                                <path
                                                    d="M10.0026 9.97654C11.0822 9.97654 12.1617 9.9974 13.2412 9.96611C13.9296 9.94525 14.6441 10.425 14.6806 11.296C14.7119 12.0522 14.0965 12.6623 13.2725 12.6832C12.8136 12.6936 12.3494 12.6884 11.8853 12.6884C10.2008 12.6884 8.51633 12.6884 6.83184 12.6884C6.35205 12.6884 5.92441 12.5685 5.61672 12.1825C5.26209 11.7392 5.19429 11.249 5.44462 10.7379C5.68451 10.2477 6.09129 9.97654 6.6441 9.97654C7.76535 9.97654 8.88139 9.97654 10.0026 9.97654ZM9.99221 11.9687C10.7015 11.9687 11.4107 11.9687 12.12 11.9687C12.5111 11.9687 12.9022 11.9739 13.2882 11.9687C13.6584 11.9635 13.9401 11.708 13.9557 11.369C13.9766 11.0143 13.7471 10.7484 13.3716 10.691C13.2934 10.6806 13.2152 10.6754 13.1369 10.6754C11.0352 10.6754 8.93354 10.6754 6.83706 10.6754C6.71711 10.6754 6.60238 10.6858 6.48764 10.7119C6.22167 10.7797 6.02871 11.0196 6.01828 11.2907C6.00264 11.6819 6.28947 11.9687 6.71189 11.9687C7.80707 11.9739 8.90225 11.9687 9.99221 11.9687Z"
                                                    fill="#329993"
                                                />
                                            </svg>
                                        </button>
                                        <div className="">
                                            <Dropdown
                                                isOpen={btnprimary1}
                                                toggle={() =>
                                                    setBtnprimary1(!btnprimary1)
                                                }
                                                style={{
                                                    padding: "0px 8px",
                                                    marginTop: "4px",
                                                }}
                                            >
                                                <DropdownToggle
                                                    type="button"
                                                    tag="button"
                                                    style={{
                                                        marginBottom: "8px",
                                                        padding: "0",
                                                        backgroundColor: "transparent",
                                                        border: "none",
                                                        borderRadius: "5px",
                                                    }}
                                                >
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="19"
                                                        height="17"
                                                        viewBox="0 0 19 17"
                                                        fill="none"
                                                    >
                                                        <rect
                                                            x="5"
                                                            width="14"
                                                            height="3"
                                                            rx="1.5"
                                                            fill="#FF7049"
                                                        />
                                                        <circle
                                                            cx="1.5"
                                                            cy="1.5"
                                                            r="1.5"
                                                            fill="#FF7049"
                                                        />
                                                        <rect
                                                            x="9"
                                                            y="14"
                                                            width="10"
                                                            height="3"
                                                            rx="1.5"
                                                            fill="#FF7049"
                                                        />
                                                        <circle
                                                            cx="5.5"
                                                            cy="15.5"
                                                            r="1.5"
                                                            fill="#FF7049"
                                                        />
                                                        <rect
                                                            y="7"
                                                            width="14"
                                                            height="3"
                                                            rx="1.5"
                                                            fill="#FF7049"
                                                        />
                                                        <circle
                                                            cx="17.5"
                                                            cy="8.5"
                                                            r="1.5"
                                                            fill="#FF7049"
                                                        />
                                                    </svg>
                                                </DropdownToggle>
                                                <DropdownMenu>
                                                    <DropdownItem
                                                        onClick={() => { }}
                                                    >
                                                        Copier vers
                                                    </DropdownItem>
                                                    <DropdownItem
                                                        onClick={() => { }}
                                                    >
                                                        Déplacer vers
                                                    </DropdownItem>
                                                    <DropdownItem
                                                        onClick={() => { }}
                                                    >
                                                        Supprimer
                                                    </DropdownItem>
                                                </DropdownMenu>
                                            </Dropdown>
                                        </div>
                                    </div>
                                </Row>
                                
                               
                                <Col md={12}>
                                    <div className="form-floating mb-3">
                                        <select
                                            className="form-select"
                                            id="floatingSelectGrid"
                                            aria-label="Floating label select example"
                                            value={selectedTimezone}
                                            style={{backgroundColor: "#FFF", border: "none", height: "100px", borderRadius: "20px",}}
                                            onChange={(e) => setSelectedTimezone(setUtc(e.target.value))}
                                        >
                                            <option value={selectedTimezone}>{selectedTimezone}</option>
                                            {timezones.map((timezone) => (
                                                <option key={timezone} value={timezone}>
                                                    {setUtc(timezone)}
                                                </option>
                                            ))}
                                        </select>
                                        <label htmlFor="floatingSelectGrid">
                                            <p>Fuseau sélectionné: {selectedTimezone}</p>
                                        </label>
                                    </div>
                                </Col>
                                <Row className="" style={{marginTop:"39px"}}>
                                    <Col md={2}>
                                        <div className="d-flex flex-column">
                                            {daysOfWeek.map(day => (
                                                <div style={{}}
                                                    key={day}
                                                    className="form-check d-flex align-items-center gap-3 mb-4"
                                                >
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        defaultValue=""
                                                        id={`inlineCheck-${day}`}
                                                        checked={(timesByDay[day].checked !== null ? timesByDay[day].checked : false)}

                                                        onClick={() => handleTimeChange(day, 'checked', timesByDay[day].checked ? false : true)}
                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor={`inlineCheck-${day}`}
                                                    >
                                                        {getFrenchTag(day)}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                    </Col>
                                    <Col md={10}>
                                        <Row>
                                            <Col md={6}>
                                                <div className="d-flex flex-column">
                                                    {daysOfWeek.map(day => (
                                                        <InputGroup key={day} className="mb-4">
                                                            <Flatpickr style={{ height: '55px', border: "none"}}
                                                                className="form-control"
                                                                disabled={!timesByDay[day].checked}
                                                                placeholder={(new Date(timesByDay[day].open) instanceof Date && new Date(timesByDay[day].close).toString() !== 'Thu Jan 01 1970 01:00:00 GMT+0100 (heure normale d’Afrique de l’Ouest)' ? new Date(timesByDay[day].open).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : "Ouverture")}
                                                                options={{
                                                                    allowInput: true,
                                                                    enableTime: true,
                                                                    noCalendar: true,
                                                                    dateFormat: "H:i",
                                                                    time_24hr: true,
                                                                    // defaultHour:  timesByDay[day].open instanceof Date ? timesByDay[day].open.getHours() : 12,
                                                                }}
                                                                onChange={([time]) => handleTimeChange(day, 'open', time.getTime())}
                                                            />
                                                        </InputGroup>
                                                    ))}
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="d-flex flex-column">
                                                    {daysOfWeek.map(day => (
                                                        <InputGroup key={day} className="mb-4">
                                                            <Flatpickr style={{ height: '55px', border: "none" }}
                                                                className="form-control"
                                                                disabled={!timesByDay[day].checked}
                                                                placeholder={
                                                                    (new Date(timesByDay[day].close) instanceof Date && new Date(timesByDay[day].close).toString() !== 'Thu Jan 01 1970 01:00:00 GMT+0100 (heure normale d’Afrique de l’Ouest)')
                                                                        ? new Date(timesByDay[day].close).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
                                                                        : "Fermeture"
                                                                }
                                                                // placeholder={(new Date (timesByDay[day].close) instanceof Date ? new Date (timesByDay[day].close).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : "Fermeture")}
                                                                options={{
                                                                    allowInput: true,
                                                                    enableTime: true,
                                                                    noCalendar: true,
                                                                    dateFormat: "H:i",
                                                                    time_24hr: true,
                                                                    // defaultHour:  timesByDay[day].close instanceof Date ? timesByDay[day].open.getHours() : 12,

                                                                }}
                                                                onChange={([time]) => handleTimeChange(day, 'close', time.getTime())}
                                                            />
                                                        </InputGroup>
                                                    ))}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                               
                                    
                                </Row>
                                <button className="btn action-btn"
                                        style={{float: "inline-end"}}
                                        >
                                            {svgs.plus_icon} {loading ? <div style={{ textAlign: "center" }}><Spinner animation="border" /> </div> : "Enregister"}
                                        </button>
                            </CardBody>
                        </Card>
                    </Col>
                </form>
                {Object.keys(formErrors).length > 0 && (
                    <div className="alert alert-danger">
                        {Object.keys(formErrors).map(day => (
                            <p key={day}>{`${getFrenchTag(day)}: ${formErrors[day]}`}</p>
                        ))}
                    </div>
                )} */}

          {/* ) : (<div>Loading</div>)} */}

          <div
            className="store-connection"
            style={{
              borderRadius: "10px",
              marginBottom: "40px",
              background: "#FFF",
              border: "1px solid rgb(233, 236, 239)",
              padding: "41px 80px 60px 65px"
            }}
          >
            <Row className="mb-3">
              <div className="d-flex align-items-center flex-wrap gap-2">
                {/* {svgs.e_commerce} */}
                <span className="font-primary">
                  <div className="stepTitle font-primary">
                    {props.t("Site web")}
                  </div>
                </span>
              </div>
              <div>
                {!savedDomain
                  ? props.t(
                      "Veuillez entrer le nom de domaine de votre site web"
                    )
                  : ""}
              </div>
            </Row>
            <div className="d-flex row">
              {savedDomain === undefined ||
              savedDomain === "" ||
              savedDomain === null ? (
                <div className="d-flex gap-3 align-items-center">
                  {/* 
                  <div className="input-group">
                    <div className="input-group-prepend">
                      <span className="input-group-text" id="domainInput" style={{ height: "100%" }}>
                        @
                      </span>
                    </div>
                    <Input
                      type="text"
                      className="form-control"
                      id="domainInput"
                      onChange={handleChange}
                      onBlur={handleOnBlur}
                      invalid={!isValid}
                      placeholder="domain.com"
                    />
                    <FormFeedback>{props.t("Veuillez entrer un nom de domaine valide.")}</FormFeedback>
                  </div> */}

                  <Form>
                    <FormGroup>
                      <InputGroup style={{ minWidth: "400px" }}>
                        <InputGroupText
                          style={{
                            height: "55px !important",
                            alignItems: "center"
                          }}
                        >
                          https://
                        </InputGroupText>
                        <Input
                          type="text"
                          id="domainInput"
                          style={{ paddingLeft: "10px" }}
                          value={domain}
                          onChange={handleChange}
                          onBlur={handleOnBlur}
                          invalid={!isValid}
                          placeholder="domain.com"
                        />
                      </InputGroup>
                      {!isValid && (
                        <div style={{ color: "red" }}>
                          {props.t("Veuillez entrer un nom de domaine valide.")}
                        </div>
                      )}
                    </FormGroup>
                  </Form>
                  <button
                    type="button"
                    className="view-button"
                    style={{
                      cursor: !isValid ? "not-allowed" : "pointer",
                      disabled: !isValid,
                      marginBottom: isValid === false ? "30px" : "15px",
                      // marginLeft: "auto",
                      backgroundColor: "#563BFF"
                      // Ajout de la propriété marginLeft avec la valeur auto
                    }}
                    onClick={() => {
                      handleOnBlur();
                      if (domain) {
                        addDomaine();
                      }
                    }}
                  >
                    {loadingDomain && (
                      <span
                        className="spinner-border spinner-border-sm me-2 font-primary"
                        role="status"
                        aria-hidden="true"
                      />
                    )}
                    {props.t("Enregistrer")}
                  </button>
                </div>
              ) : (
                <div
                  className="align-items-center"
                  style={{
                    margin: "15px 15x 0px 0px"
                  }}
                >
                  <div className="col-auto">
                    <div className="font-primary">
                      <>
                        <div>
                          {props.t("Nom de domaine de votre site web ajouté")}{" "}
                          <span style={{ color: "#563BFF" }}>
                            <CheckCircleRounded width={24} height={24} />
                          </span>
                        </div>
                        <div style={{ fontWeight: "500" }}>
                          {props.t("Domaine")} :{" "}
                          <span
                            className="badge p-2"
                            style={{
                              borderRadius: "10px",
                              backgroundColor: "#d7fee1",
                              color: "#046c28"
                            }}
                          >
                            {savedDomain}
                          </span>
                        </div>
                        {/* <Link
                          className="underline-a"
                          to={"#"}
                          style={{ width: "fit-content" }}
                          onClick={() => {
                            toggleDeleteDomain();
                          }}>
                          {loading && <span className="spinner-border spinner-border-sm me-2 font-primary" role="status" aria-hidden="true" />}
                          {props.t("Supprimer le nom de domaine")}
                        </Link> */}
                      </>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* <div
            className="store-connection"
            style={{
              borderRadius: "15px",
              background: "#FFF",
              boxShadow: "0px 6px 24px 1px rgba(53, 22, 252, 0.10)",
              padding: "41px 80px 60px 65px"
            }}
          >
            <Row className="mb-3">
              <div className="d-flex align-items-center flex-wrap gap-2">
                <span className="font-primary">
                  <div className="stepTitle font-primary">
                    {props.t("Connecter votre E-commerce")}
                  </div>
                </span>
              </div>
              <div>{props.t("general_shopify_subtitle_1")}</div>
            </Row>
            <div className="d-flex row">
              <div className="d-flex gap-3 align-items-center">
                <label
                  className="font-primary mb-0"
                  style={{
                    fontSize: "14px",
                    fontStyle: "normal",
                    fontWeight: "600",
                    lineHeight: "normal"
                  }}
                >
                  {props.t("Votre CMS")} :
                </label>
                <Dropdown
                  isOpen={cmsDropdown}
                  toggle={() => setCmsDropdown(!cmsDropdown)}
                >
                  <DropdownToggle
                    tag="button"
                    className="form-control py-0"
                    style={{ textTransform: "capitalize" }}
                  >
                    {selectedCms === "Shopify"
                      ? svgs.shopify_icon
                      : selectedCms === "Woocommerce"
                      ? svgs.woocommerce_icon
                      : selectedCms === "Magento"
                      ? svgs.magento_icon
                      : svgs.prestashop_icon}{" "}
                    {selectedCms}
                    <i className="ms-2 mdi mdi-chevron-down" />
                  </DropdownToggle>
                  <DropdownMenu className="dropdown-menu-lg-end">
                    <DropdownItem
                      onClick={() => {
                        setSelectedCms("Woocommerce");
                      }}
                    >
                      Woocommerce
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => {
                        setSelectedCms("Magento");
                      }}
                    >
                      Magento
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => {
                        setSelectedCms("Shopify");
                      }}
                    >
                      Shopify
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => {
                        setSelectedCms("Prestashop");
                      }}
                    >
                      Prestashop
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </div>
              {selectedCms === "Shopify" ? (
                <div
                  className="align-items-center"
                  style={{
                    margin: "30px 30px 0px 0px"
                  }}
                >
                  <div className="col-auto">
                    <div className="font-primary">
                      {client_data &&
                        client_data.shopify_token &&
                        client_data.shopify_store_url && (
                          <>
                            <div>
                              {props.t(
                                "La connexion à votre boutique est active"
                              )}{" "}
                              <span style={{ color: "#563BFF" }}>
                                <CheckCircleRounded width={24} height={24} />
                              </span>
                              <div style={{ fontWeight: "500" }}>
                                {props.t("URL de la boutique")} :{" "}
                                <span
                                  className="badge p-1"
                                  style={{
                                    borderRadius: "10px",
                                    backgroundColor: "#d7fee1",
                                    color: "#046c28"
                                  }}
                                >
                                  {client_data.shopify_store_url}
                                </span>
                              </div>
                            </div>
                          </>
                        )}
                    </div>
                  </div>

                  {client_data &&
                    (!client_data.shopify_token ||
                      !client_data.shopify_store_url) && (
                      <>
                        <Col lg="6" className="">
                          <div className="mt-3 font-primary d-flex align-items-center gap-2">
                            {props.t(
                              "Connexion non établie. Installez Synibox pour"
                            )}
                            {` ${selectedCms}`}
                            <AlertTriangeMono
                              width={"30px"}
                              height={"30px"}
                              className=""
                            />
                          </div>
                          <button
                            type="button"
                            className="view-button mt-2"
                            style={{
                              backgroundColor: "#563BFF"
                            }}
                            onClick={() => {
                              // navigate(`https://admin.shopify.com/store/`, {
                              //   replace: false,
                              // });
                              window.location.href =
                                "https://apps.shopify.com/synibox";
                            }}
                          >
                            {props.t("Install Shopify App")}
                          </button>
                        </Col>
                      </>
                    )}
                </div>
              ) : (
                <div className="mt-3 ms-4 font-primary ">
                  <div className="d-flex align-items-center gap-2">
                    {props.t("Bientôt disponible")}{" "}
                    <AlertTriangeMono
                      width={"30px"}
                      height={"30px"}
                      className=""
                    />
                  </div>
                </div>
              )}
            </div>
          </div> */}

          {/* <Card className="mt-5" style={{ borderRadius: "15px", boxShadow: "0px 6px 24px 1px rgba(53, 22, 252, 0.10)", padding: '46px 34px 79px 38px' }}>
                    <CardBody className="p-0"> */}

          {/* </CardBody>
                </Card> */}

          {/* Informations sur votre entreprise */}
          {/* <Col xxl={10} lg={12} style={{marginTop:"50px", marginRight:"auto", marginLeft:"auto"}}>
                    <Card className="company-infos__container" style={{borderRadius:"20px", boxShadow:"none", padding:"50px 28px"}}>
                        <CardBody>
                            <h4 className="card-title"
                            style={{
                                marginBottom : "40px",
                                color: "var(--colors-black-100, #091B3D)",
                                fontFamily: "Poppins, sans-serif",
                                fontSize: "28px",
                                fontStyle: "normal",
                                fontWeight: "500",
                                lineHeight: "normal",
                            }}
                            >Informations sur votre entreprise</h4>
                            <Row>
                                <div>
                                    <Form
                                        onSubmit={(e) => {
                                            e.preventDefault();
                                            validationType.handleSubmit();
                                            updateCompanyInfos({
                                                company: site_name,
                                                company_website_url: site_url,
                                                more_info: site_infos_more,
                                                shopify_store_url: shopify_store_url,
                                                shopify_api_key: shopify_api_key,
                                            })
                                            return false;
                                        }}>
                                        <Row>
                                            <Col lg={12}>
                                                <FormGroup className="mb-0 row align-items-center">
                                                    <Col lg={3}>
                                                        <Label htmlFor="basicpill-vatno-input62">
                                                            Nom du site
                                                        </Label>
                                                    </Col>
                                                    <Col lg={9}>
                                                        <Input
                                                            type="text"
                                                            className="form-control"
                                                            id="basicpill-vatno-input62"
                                                            placeholder="Entrez le nom du site"
                                                            value={site_name}
                                                            onChange={(e) => setSiteName(e.target.value)}
                                                        />
                                                    </Col>
                                                    
                                                </FormGroup>
                                                 <FormGroup className="mb-0 row align-items-center">
                                                    <Col lg={3}>
                                                        <Label htmlFor="basicpill-vatno-input62">
                                                            URL du site
                                                        </Label>
                                                    </Col>
                                                    <Col lg={9}>
                                                        <div className="input-group">
                                                            <div className="input-group-text">https://</div>
                                                            <input


                                                                type="text"
                                                                className="form-control"
                                                                placeholder="URL du site"
                                                                value={site_url}
                                                                onChange={(e) => setSiteUrl(e.target.value)}
                                                            />
                                                        </div>
                                                    </Col>
                                                </FormGroup>
                                                <FormGroup className="row mb-0 align-items-center" style={{marginBottom:"0px"}}>
                                                    <Col lg={3}>
                                                        <Label htmlFor="basicpill-vatno-input62">
                                                            URL boutique shopify
                                                        </Label>
                                                    </Col>
                                                    <Col lg={9}>
                                                        <div className="input-group">
                                                            <div className="input-group-text">https://</div>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                id="inlineFormInputGroupUsername"
                                                                placeholder="Entrez l'url au format boutique.myshopify.com"
                                                                value={shopify_store_url}
                                                                onChange={(e) => setShopifyStoreUrl(e.target.value)}
                                                            />
                                                        </div>
                                                    </Col>
                                                </FormGroup>
                                                <FormGroup className="mb-0 row align-items-center">
                                                    <Col lg={3}>
                                                        <Label className="form-label">Clé API SHOPIFY</Label>
                                                    </Col>
                                                    <Col lg={9}>
                                                        <Input
                                                            name="shopify_key"
                                                            placeholder="Entrez ici votre clé API SHOPIFY"
                                                            type="text"
                                                            value={shopify_api_key}
                                                            onChange={(e) => setShopifyStoreApiKey(e.target.value)}

                                                        />
                                                        </Col>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </Form>
                                </div>
                            </Row>
                            <button
                                type="button"
                                style={{ '--theme-color': selectedColor, float: "inline-end" }}
                                className={`btn mt-3 action-btn waves-effect waves-light changingColor ${requiredValidations() === false ? 'disabled' : ""}`} onClick={() => {
                                    updateCompanyInfos({
                                        company: site_name,
                                        company_website_url: site_url,
                                        more_info: site_infos_more,
                                        shopify_store_url: shopify_store_url,
                                        shopify_api_key: shopify_api_key,
                                    });
                                }}
                            >
                                {svgs.plus_icon}{loading ? <div style={{ textAlign: "center" }}><Spinner animation="border" /> </div> : "Enregister"}
                            </button>
                        </CardBody>
                    </Card>
                </Col> */}

          {/* <Col lg="12">
                    <Card>
                        <CardBody>
                            <h4 className="card-title ">Theme</h4>
                            <p className="mb-4">Couleur du thème</p>
                            <div>
                                <div className="color-selector mb-4" style={{ display: "flex" }}>
                                    {colors.map((color) => (
                                        <div
                                            key={color}
                                            onClick={() => handleColorSelect(color)}
                                            className={`color-circle ${selectedColor === color ? "selected" : ""}`}
                                            style={{
                                                backgroundColor: `${color}`,
                                                marginRight: "10px",
                                                width: "28px",
                                                height: "28px",
                                                borderRadius: "50%",
                                                cursor: "pointer",
                                                // border: selectedColor === color ? "3px solid red" : "none",  
                                            }}
                                        >
                                            {selectedColor === color && (
                                                <div
                                                    style={{
                                                        border: "3px solid white",
                                                        width: "20px",
                                                        height: "20px",
                                                        borderRadius: "50%",
                                                        position: "relative",
                                                        marginTop: "4px",
                                                        marginLeft: "4px",
                                                    }}
                                                >
                                                </div>

                                            )}
                                        </div>
                                    ))}
                                </div>
                                <button style={{ '--theme-color': selectedColor }} onClick={() => applyColorSelect()} type="button" className="btn btn-light changingColor btn-rounded waves-effect"  >
                                    Changer la couleur du theme
                                </button>
                            </div>

                        </CardBody>
                    </Card>
                </Col> */}
          <Modal
            isOpen={isDiconnected}
            toggle={() => toggleDisconnect()}
            centered
            className="user-modal"
          >
            <ModalBody className="p-3">
              <h4 className="font-primary">
                {props.t("Déconnexion de la boutique")}
              </h4>
              <p className="text-muted">
                {props.t("Voulez-vous vraiment déconnecter la boutique ?")}
              </p>
            </ModalBody>
            <ModalFooter>
              <div
                className="hstack gap-2 justify-content-end"
                style={{ width: "100%" }}
              >
                <button
                  type="button"
                  className="view-button"
                  style={{ color: "black", width: "100%" }}
                  onClick={() => toggleDisconnect()}
                >
                  {props.t("Non")}
                </button>
                <button
                  type="button"
                  style={{ backgroundColor: "#563bff", width: "100%" }}
                  className="view-button center font-primary"
                  id="edit-btn"
                  onClick={() => disconnectStore()}
                >
                  {loading ? (
                    <span
                      className="spinner-border spinner-border-sm me-2 font-primary"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : (
                    props.t("Oui")
                  )}
                </button>
              </div>
            </ModalFooter>
          </Modal>

          <Modal
            isOpen={isDeleteDomain}
            toggle={() => toggleDeleteDomain()}
            centered
            className="user-modal"
          >
            <ModalBody className="p-3">
              <h4 className="font-primary">
                {props.t("Suppression du nom de domaine")}
              </h4>
              <p className="text-muted">
                {props.t("Voulez-vous vraiment supprimer le nom de domaine ?")}
              </p>
            </ModalBody>
            <ModalFooter>
              <div
                className="hstack gap-2 justify-content-end"
                style={{ width: "100%" }}
              >
                <button
                  type="button"
                  className="view-button"
                  style={{ color: "black", width: "100%" }}
                  onClick={() => toggleDeleteDomain()}
                >
                  {props.t("Non")}
                </button>
                <button
                  type="button"
                  style={{ backgroundColor: "#563bff", width: "100%" }}
                  className="view-button center font-primary"
                  id="edit-btn"
                  onClick={() => deleteDomain()}
                >
                  {loading ? (
                    <span
                      className="spinner-border spinner-border-sm me-2 font-primary"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : (
                    props.t("Oui")
                  )}
                </button>
              </div>
            </ModalFooter>
          </Modal>
          <div
            className="position-fixed bottom-0 end-0 p-3"
            style={{ zIndex: "1005" }}
          >
            <CustomToast
              isOpen={toast}
              toggle={toggleToast}
              message={toastMessage}
            />
          </div>
        </Container>
      ) : (
        <div style={{ textAlign: "center", fontSize: "14px" }}>
          <Spinner
            className="me-1"
            style={{ height: "15px", width: "15px" }}
            animation="border"
          />
          {props.t("Chargement") + "..."}
        </div>
      )}
    </React.Fragment>
  );
};

export default withTranslation()(General);
